import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CSSModules from 'react-css-modules'
import SessionFetchedEvent from 'javascripts/layouts/v2/SessionFetchedEvent'
import LazyImg from 'javascripts/common/LazyImg'
import FavoriteIcon from 'images/favorite_job_offers/favorite_job_offers.svg'
import BookmarkIcon from 'images/job_offers/searching_bookmarks/icon_search.svg'
import HistoryIcon from 'images/job_offers/application_histories/icon_paper_airplane.svg'
import * as Routes from 'routes'
import styles from './JobOfferSideNav.module.scss'

type JobOfferSideNavProps = {
  notice?: boolean
}

const JobOfferSideNav: React.FC<JobOfferSideNavProps> = (props) => {
  const [login, setLogin] = useState<boolean>(false)
  const [notice, setNotice] = useState<boolean>(props.notice ?? true)

  useEffect(() => {
    document.addEventListener('session:fetched', (event: SessionFetchedEvent) => {
      if (event.detail.session.user) {
        setLogin(true)
      }
    })

    if (localStorage.getItem('visited03')) {
      setNotice(false)
    }
    else {
      localStorage.setItem('visited03', '1')
      setNotice(true)
    }
  }, [])

  const renderApplicationHistory = () => {
    if (!login) return null

    return (
      <a
        href={Routes.job_offers_application_histories_path()}
        id='ga-application-histories'
        styleName='sidenav-item'
        data-turbo='false'
      >
        <span styleName='hover-item'>応募履歴</span>
        <LazyImg styleName='img-item' src={HistoryIcon} />
      </a>
    )
  }

  const renderNotice = () => {
    if (!notice) return null

    const msg = <span>お気に入りの機能を使って、より便利にお仕事探しができます。</span>
    const loginMsg = <span>お気に入り、検索条件の保存、応募履歴の機能を<br />使って、より便利にお仕事探しができます。</span>

    return (
      <div styleName='notice' className={login ? 'notice' : 'notice-f'}>
        <div styleName='modal-dialog'>
          <div styleName='modal-content'>
            <button styleName='notice-modal-close' type='button' data-bs-dismiss='modal' area-label='Close' onClick={() => setNotice(false)}>
              <FontAwesomeIcon icon={['fas', 'times']} />
            </button>
            <div styleName='notice-modal-text'>
              {login ? loginMsg : msg}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {renderNotice()}
      <div className='job-offers-sidenav d-none d-lg-block' styleName='job-offers-sidenav'>
        <a
          href={Routes.favorite_job_offers_path()}
          id='ga-favorite-job-offers'
          styleName='sidenav-item'
          data-turbo='false'
        >
          <span styleName='hover-item'>気になったお仕事</span>
          <LazyImg styleName='img-item' src={FavoriteIcon} />
        </a>
        <a
          href={Routes.searching_bookmarks_path()}
          id='ga-searching-bookmarks'
          styleName='sidenav-item'
          data-turbo='false'
        >
          <span styleName='hover-item'>保存した条件</span>
          <LazyImg styleName='img-item' src={BookmarkIcon} />
        </a>
        {renderApplicationHistory()}
      </div>
    </>
  )
}

export default CSSModules<typeof JobOfferSideNav>(JobOfferSideNav, styles)
